// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2Qrur","left":"InfoRow_left__1_rSu"};